var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"avatar-container",style:(_vm.style),attrs:{"aria-hidden":"true"}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.userInitial))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }